<template>
  <b-nav-item
    right
    :title="$t('Legal Warning')"
    @click="showLegal"
  >
    <feather-icon
      class="text-body"
      icon="InfoIcon"
      size="21"
    />
  </b-nav-item>
</template>

<script>
import {
  BNavItem,
} from 'bootstrap-vue'

export default {
  components: {
    BNavItem,
  },
  data() {
    return {
    }
  },
  methods: {
    showLegal() {
      this.$swal({
        title: this.$t('Legal Warning'),
        html: this.$t('legal'),
        width: '90%',
        icon: 'warning',
        showCancelButton: false,
        confirmButtonText: this.$t('Continue'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          localStorage.setItem('legal', true)
        }
      })
    },
  },
}
</script>

<style>

</style>
